// extracted by mini-css-extract-plugin
module.exports = {"main":"NavbarMenuWithTabs_main__3rR98","titleSpan":"NavbarMenuWithTabs_titleSpan__1FwEc","tabsDiv":"NavbarMenuWithTabs_tabsDiv__eXAgA","hidden":"NavbarMenuWithTabs_hidden__2KPnu"};